<form
	[formGroup]="formGroup"
	[ngClass]="{'mt-5': addSpaceToPrevious}"
>
	<div
		class="row mb-3 formElementWrapper"
		[ngClass]="baseCssClass"
		(mouseover)="setHovered( true )"
		(mouseout)="setHovered( false )"
	>

		<!-- Label -->
		<ng-container *ngIf="!config.hideLabel">
			<app-label
				formEntityId="{{formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId}}"
				labelText="{{ labelText ? labelText : getI18nString(false, translationPath + '.label') }}"
				[labelClassObject]="{
					'hovered': isHovered,
					'focused': hasFocus,
					'error': control?.errors && !hideErrors
				}"
				[formControlInline]="formControlInline"
				[labelHostClassString]="labelHostClassString"
				[labelInfoInline]="labelInfoInline"
				[required]="isRequired"
				[requiredByElster]="config.elsterRequiredField"
				[showElsterIndicator]="config.elsterShowIndicator"
			></app-label>
		</ng-container>

		<!-- Input Block -->
		<div class="inputBlockWrapper col-12 col-md-8">

			<div class="col-{{colSpan}} px-0">
				<!-- Input Wrapper -->
				<div
					class="switchWrapper mb-1"
					[ngClass]="{
						'hovered': isHovered,
						'focused': hasFocus,
						'error': control?.errors && !hideErrors
				 	}"
				>

					<!-- Input Group -->
					<div class="row gx-0">
						<!-- Switch -->
						<ui-switch
							formControlName="{{formControlNameOverwrite ? formControlNameOverwrite : formEntityId}}"
							id="{{formEntityIdOverwrite ? formEntityIdOverwrite : formEntityId}}"
							size="{{size}}"
							tabindex="{{config.tabindex}}"
							[attr.data-e2e]="formEntityId + '-switch'"
							[checked]="isChecked"
							[appDisableControl]="{condition: disableControl, control: control}"
							(change)="onChange($event)"
						></ui-switch>
					</div>
				</div>

				<!-- Error -->
				<app-error
					[control]="control"
					[errorMsg]="errorMsg"
					[hideErrors]="hideErrors || hideErrorDescriptions"
				></app-error>
			</div>

			<!-- Input Information -->
			<app-info
				[baseClass]="'col-12 mb-3 mt-2 px-0'"
				[hideInfoIcon]="true"
				[infoText]="getI18nString( false, translationPath + '.info' )"
			></app-info>
		</div>
	</div>
</form>
